module.exports = __webpack_public_path__ + "static/media/kingsalmon.5453e223.png";